// confirmar-informacion-propietario-moral.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment.production';
import { ConfirmarInformacionResponse } from '../pojos/ConfirmarInformacionResponseVo'; // Ajusta ruta si es necesario
import { DefaultErrorMessage, ErrorMessages } from '../components/catalogoErrores/error-messages';

@Injectable({
  providedIn: 'root',
})
export class ConfirmarInformacionPropietarioMoralService {
  private readonly endPoint = `${environment.HOST}/confirmarInformacionPropietarioMoral`;

  constructor(private http: HttpClient) {}

  confirmar(strRfcIngresado: string, strRfcEncontrado: string): Observable<ConfirmarInformacionResponse> {
    if (!strRfcIngresado?.trim()) {
      return throwError(() => this.createValidationError('RFC ingresado no puede estar vacío'));
    }
    if (!strRfcEncontrado?.trim()) {
      return throwError(() => this.createValidationError('RFC encontrado no puede estar vacío'));
    }

    const params = new HttpParams()
      .set('strRfcIngresado', strRfcIngresado)
      .set('strRfcEncontrado', strRfcEncontrado);

    return this.http.get<ConfirmarInformacionResponse>(this.endPoint, { params }).pipe(
      catchError((error) => {
        const customError = {
          originalError: error,
          timestamp: new Date().toISOString(),
          userMessage: error.error?.descripcionCodigo ||
            ErrorMessages[error.error?.idCodigo] ||
            ErrorMessages[error.status] ||
            DefaultErrorMessage,
          context: {
            endpoint: this.endPoint,
            params: { strRfcIngresado, strRfcEncontrado },
          },
        };
        console.error(customError);
        return throwError(() => customError);
      })
    );
  }

  private createValidationError(message: string) {
    return {
      type: 'VALIDATION_ERROR',
      message,
      userMessage: message,
      timestamp: new Date().toISOString(),
    };
  }
}
